module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Explore Baianat","pageDesc":"Discover more about Baianat company and its services, work, ventures, events, books, labs, atlas, arcade and more.","mantra":"Discover Baianat."},"ar":{"pageTitle":"اكتشف بيانات","pageDesc":"اكتشف المزيد حول ما تقدمه شركة بيانات وخدماتها وأعمالها ومشاريعها والفعاليات التي تؤسسها والكتب والمختبرات والمراكز وأطلس.","mantra":"اكتشف بيانات"}}')
  delete Component.options._Ctor
}
